import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";

import {
  PreviewRecipe,
  PreviewContent,
  PreviewInfo,
  PreviewImg,
  PreviewTime,
  PreviewTags,
  PreviewDesc,
  CategoryRecipe,
  NoImage,
  MainImage,
} from "components/RecipeSteps/Preview/styled";
import Button from "shared/Button";
import BtnToolBar from "shared/BtnToolBar/index";
import Rating from "shared/Rating";
import { PreviewButtons, Wraper, WraperDesktop, RatingWrapMobile, RatingText, BtnToolbarWrapMobile } from "./styled";
import { TextBold } from "styles/General.styled";
import { PreviewBarWrapRecipe } from "styles/Preview.styled";
import { MainWrap, SpinnerWrap } from "./styled";
import BuyInAppModal from "components/BuyInAppModal";

import { showVideoModal, togglePamentModal, hideVideoModal, togglePaidInCollectionModal } from "store/modalReducer";

import { colors } from "styles/colors";
import { getRatingsMessage } from "../../helpers/getRatingsMessage";
import Collapse from "shared/Collapse";
import cloudfront from "helpers/cloudfront";

import MadeItButton from "components/MadeItButton";
import { useRenderDevice } from "helpers/hooks/useRenderDevice";

import { Spinner } from "styles/App.styled";
import { paymentBuying } from "store/paymentReducer";

const creatorBtns = [
  { name: "Edit", icon: "edit_large" },
  { name: "Share", icon: "share2" },
  { name: "Like", icon: "saveslide" },
];

const viewerBtns = [
  { name: "Share", icon: "share2" },
  { name: "Like", icon: "saveslide" },
];

const MyRecipe = ({
  id,
  image,
  prepare_ahead,
  tags,
  isCreator,
  description,
  paid,
  purshased,
  setVideoPage,
  video,
  saved,
  handleClick,
  isPrivate,
  showStepsButton,
  onEdit,
  rating,
  review_count,
  price,
  madeIt,
  canMadeIt,
}) => {
  const router = useRouter();
  const btns = isCreator && !router.query.collection ? creatorBtns : viewerBtns;
  const isMobile = useRenderDevice({ max: 769 });
  const [buyInAppModalVisible, setBuyInAppModalVisible] = useState(false);

  const dispatch = useDispatch();
  const loading = useSelector(paymentBuying);

  const showModal = () => {
    setVideoPage(true);
    dispatch(showVideoModal());
  };

  useEffect(() => () => dispatch(hideVideoModal()), []);

  const showStepModal = () => {
    setVideoPage(false);
    dispatch(showVideoModal());
  };

  const showPayment = () => {
    setBuyInAppModalVisible(false);
    dispatch(togglePamentModal(true));
  };

  const renderBtn = () => {
    if (purshased) {
      return <Button type="primary" text="Purchased" disabled id="bought" />;
    }

    if (isPrivate) {
      return (
        <Button
          onClick={() => dispatch(togglePaidInCollectionModal(true))}
          stylType="primary"
          color={colors.RED}
          text="Buy in Collection"
          id="bought"
        />
      );
    }
    if (paid) {
      return (
        <Button
          stylType="primary"
          text={`Buy for $${price}`}
          id="buy"
          color={colors.RED}
          onClick={() => {
            setBuyInAppModalVisible(true);
          }}
          loading={loading}
          disabled={loading}
        />
      );
    } else return <Button stylType="primary" text="Free" disabled id="free" />;
  };

  const [imageLoading, setImageLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      if (imageLoading) {
        setImageLoading(false);
      }
    }, 1000);
  }, [image]);

  const closeBuyInApp = () => {
    setBuyInAppModalVisible(false);
  };

  return (
    <MainWrap>
      <PreviewRecipe>
        <PreviewImg>
          {image && imageLoading && (
            <SpinnerWrap>
              <Spinner />
            </SpinnerWrap>
          )}
          {image ? (
            <MainImage
              onLoad={() => {
                setImageLoading(false);
              }}
              src={cloudfront({ href: image, size: "large" })}
              alt="Img Preview"
            />
          ) : (
            <NoImage />
          )}
        </PreviewImg>
        <PreviewContent>
          <PreviewInfo>
            <PreviewBarWrapRecipe>
              {!isMobile && (
                <WraperDesktop>
                  {prepare_ahead && (
                    <PreviewTime>
                      Prep ahead: <TextBold>{prepare_ahead}</TextBold>
                    </PreviewTime>
                  )}
                </WraperDesktop>
              )}
              {isMobile && (
                <>
                  <MadeItButton madeIt={madeIt} recipeId={id} isMobile canMadeIt={canMadeIt} />
                  <BtnToolbarWrapMobile>
                    <RatingWrapMobile hasReviews={review_count}>
                      <RatingText>{getRatingsMessage(review_count)}</RatingText>
                      <Rating value={rating} />
                    </RatingWrapMobile>
                    <BtnToolBar
                      btns={btns}
                      saved={saved}
                      onClick={onEdit}
                      onSave={handleClick}
                      socialImgUrl={image}
                      isRecipe
                      recipeId={id}
                    />
                  </BtnToolbarWrapMobile>
                </>
              )}
            </PreviewBarWrapRecipe>
            <CategoryRecipe>
              {isMobile && (
                <Wraper className="top">
                  {prepare_ahead && (
                    <PreviewTime>
                      Prep ahead: <TextBold>{prepare_ahead}</TextBold>
                    </PreviewTime>
                  )}
                </Wraper>
              )}
              <Collapse>
                {tags.map((tag) => {
                  return <PreviewTags key={tag.id}>{tag.name}</PreviewTags>;
                })}
              </Collapse>
            </CategoryRecipe>
            <PreviewDesc>{description && description.split("\n").map((val, i) => <p key={i}>{val}</p>)}</PreviewDesc>
          </PreviewInfo>
          <PreviewButtons>
            {!isCreator && <Wraper>{renderBtn()}</Wraper>}
            <Wraper>
              {!!showStepsButton && (
                <Button
                  onClick={showStepModal}
                  stylType="outline"
                  text="Start step-by-step instructions"
                  iconLeft="list_play"
                  bdButton={colors.HOME_HEADERS}
                  color={colors.WHITE}
                  textColor={colors.HOME_HEADERS}
                  border={colors.HOME_HEADERS}
                />
              )}
              {!!video && (
                <Button
                  onClick={showModal}
                  stylType="outline"
                  text="Start Video"
                  iconLeft="video-player-movie"
                  color={colors.WHITE}
                  textColor={colors.HOME_HEADERS}
                  border={colors.HOME_HEADERS}
                />
              )}
            </Wraper>
          </PreviewButtons>
        </PreviewContent>
      </PreviewRecipe>
      <BuyInAppModal isVisible={buyInAppModalVisible} onClose={closeBuyInApp} confirm={showPayment} />
    </MainWrap>
  );
};

export default MyRecipe;
